import { FuseNavigationItem } from '@fuse/components/navigation';
import { chatNavigation } from './apps/chat/chat.navigation';
import { digitaiNavigation } from './apps/digitai/digitai.navigation';
import { epacNavigation } from './apps/epac/epac.navigation';
import { iamNavigation } from './apps/iam/iam.navigation';
import { oAuthNavigation } from './apps/o-auth/o-auth.navigation';
import { supportNavigation } from './apps/support/support.navigation';
import { toolsNavigation } from './apps/tools/tools.navigation';

export const adminNavigation: FuseNavigationItem[] = [
    digitaiNavigation,
    iamNavigation,
    oAuthNavigation,
    chatNavigation,
    epacNavigation,
    supportNavigation,
    toolsNavigation,
];
